"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconReset = void 0;
var React = __importStar(require("react"));
var IconReset = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M15,8.5 C15,8.776 15.224,9 15.5,9 L21.5,9 C21.776,9 22,8.776 22,8.5 L22,2.5 C22,2.224 21.776,2 21.5,2 C21.224,2 21,2.224 21,2.5 L21,7.455 C19.302,4.626 15.875,2 12,2 C6.486,2 2,6.486 2,12 C2,17.514 6.486,22 12,22 C17.151,22 21.428,18.141 21.949,13.022 C21.977,12.747 21.776,12.502 21.502,12.475 C21.217,12.443 20.982,12.647 20.954,12.921 C20.486,17.526 16.636,21 12,21 C7.038,21 3,16.963 3,12 C3,7.037 7.038,3 12,3 C15.515,3 18.631,5.412 20.163,8 L15.5,8 C15.224,8 15,8.224 15,8.5" }))); };
exports.IconReset = IconReset;
exports.IconReset.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconReset;
